import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {OptionTable} from './table/OptionTable'
import {OptionEditModal} from './options-edit-modal/OptionEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {OptionListHeader} from './header/OptionListHeader'

const OptionList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <OptionListHeader />
        <OptionTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <OptionEditModal />}
    </>
  )
}

const OptionListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <OptionList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {OptionListWrapper}
